<div class="">
  <tx-loader-wrapper [isLoading]="loading">
    <div class="mb-2">
      <ul class="path">
        <div class="mb-2" *ngIf="path.length > 0">
          <button type="button" class="btn btn-sm me-1 p-0 px-1" (click)="goFolderUp()" title="Go one folder up">
            <i class="bi bi-arrow-up"></i>
          </button>
        </div>
        <li *ngFor="let folder of path">
          <i class="bi bi-folder-fill text-warning"></i>
          {{ folder }}
        </li>
      </ul>
    </div>
    <div class="mb-2 filter-container">
      <input
        #filterInput
        type="text"
        class="form-control"
        [(ngModel)]="searchTerm"
        placeholder="Filter documents and folders"
        (ngModelChange)="onFilterChange()" />
      <a href="#" (click)="clearFilter()" class="clear-button" *ngIf="searchTerm != ''">
        <i class="bi bi-x-lg"></i>
      </a>
    </div>
    <div class="tx-table">
      <header class="grid gap-2">
        <div class="g-col-6 d-flex gap-2">
          <button
            type="button"
            title="Add new folder"
            class="btn btn-sm me-1 p-0 px-1 bg-warning"
            (click)="addFolder()"
            *ngIf="path[0] != clientCaseFolderName">
            <i class="bi bi-plus"></i>
          </button>
          Document name
        </div>
        <div class="g-col-5">Modified date</div>
      </header>
      <div
        *ngIf="path.length <= 0 && !hideAssembledWithoutCaseFolder"
        class="grid tx-table-row"
        [ngClass]="{
          'tx-table-row-active': selectedFolder?.name === clientCaseFolder.name
        }"
        (click)="onFolderSelected(clientCaseFolder)"
        (dblclick)="onOpenAssembledNonCaseFolderClicked()">
        <div class="g-col-6 ps-1 d-flex align-items-center gap-3">
          <i class="bi bi-folder-fill text-warning"></i>
          <div class="text-truncate" [title]="clientCaseFolderName">{{ clientCaseFolderName }}</div>
        </div>
      </div>
      <div
        *ngFor="let f of filteredFolders"
        class="grid tx-table-row"
        [ngClass]="{
          'tx-table-row-active': selectedFolder?.name === f.name
        }"
        (click)="onFolderSelected(f)"
        (dblclick)="onOpenFolderClicked(f)">
        <div class="g-col-6 ps-1 d-flex align-items-center gap-3">
          <i class="bi bi-folder-fill text-warning"></i>
          <div class="text-truncate" [title]="f.name">{{ f.name }}</div>
        </div>
      </div>
      <div
        *ngFor="let f of filteredFiles"
        class="grid tx-table-row"
        [ngClass]="{
          'tx-table-row-active': isFileSelected(f)
        }"
        (click)="onFileSelected(f)"
        (dblclick)="onOpenInNewTabClicked(f)">
        <div class="g-col-6 ps-1 d-flex align-items-center gap-3">
          <i class="bi bi-file-earmark"></i>
          <div class="text-truncate" [title]="f.name">{{ f.name }}</div>
        </div>
        <div class="g-col-4">
          {{ f.lastModifiedDate != null ? (f.lastModifiedDate | date : 'MM/dd/yyyy h:mm a') : '' }}
        </div>
        <div class="action-buttons">
          <div *ngIf="allowOpen" class="d-flex align-items-center justify-content-end gap-2 h-100">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="onOpenInNewTabClicked(f)">
              Open
            </button>
          </div>
        </div>
      </div>
    </div>
  </tx-loader-wrapper>

  <form
    ngNoForm
    [action]="submitUrl"
    method="post"
    enctype="application/x-www-form-urlencoded"
    target="_blank"
    #openInNewTabForm>
    <input type="hidden" id="dcmID" name="dcmID" />
    <input type="hidden" [id]="sessionId" [name]="sessionId" />
    <input type="hidden" id="Filename" name="Filename" />
    <input type="hidden" id="Pathname" name="Pathname" />
    <input type="hidden" id="Folder" name="Folder" />
    <input type="hidden" id="IsAbsolutePath" name="IsAbsolutePath" />
  </form>
</div>
